const staticPath = "static"

export default staticPath